import styled from 'styled-components';

import { Component } from './component';

export const Styled = styled(Component)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  text-decoration: none;
  background: transparent;
  font: inherit;
  color: inherit;
  list-style: none;
  width: 100%;
`;
